import styled from "styled-components";
import Variables from "../../../../../assets/styleVariables";

export const NotificationMenuContainer = styled.div`
  padding-bottom: 12px;
  background-color: ${Variables.colors.complementary_100};
  overflow-y: auto;
  max-height: 60vh;
  .notification-title {
    padding: 12px;
    color: ${Variables.colors.complementary_700};
    font-size: ${Variables.font_sizes.x1_medium};
    margin-bottom: 16px;
    position: sticky;
    top: 0;
    z-index: 9999;
    background-color: ${Variables.colors.complementary_100};
    box-shadow: 0 0 6px 0 ${Variables.colors.complementary_450};
  }
  .notification-inner-wrapper {
    padding: 12px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px 16px 16px;
    .sort-box {
      width: 130px;
      height: 30px;
      font-size: 13px;
    }
    h1 {
      margin: 0;
      font-size: ${Variables.font_sizes.x2_large};
      color: ${Variables.colors.complementary_900};
      font-weight: ${Variables.font_weight.regular};
    }
  }
`;

export const PromoCodeRow = styled.div`
  background-color: ${Variables.colors.white};
  border-radius: 8px;
  border: 1px solid ${Variables.colors.complementary_400};
  padding: 10px 12px;
  box-shadow: 0 1px 4px 0 #ccc;
  margin: 8px 0;
  width: 100%;
  .inner-container {
    display: flex;
    flex-direction: column;
    .promoCodeLabel {
      cursor: pointer;
      width: 80%;
      margin: 0 auto;
      height: 36px;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 35px;
      position: relative;
      box-sizing: border-box;
      background-color: ${Variables.colors.primary};
      color: ${Variables.colors.complementary};
      i {
        position: absolute;
        right: 16px;
        &:before {
          color: ${Variables.colors.complementary};
          font-size: ${Variables.font_sizes.x2_medium};
        }
      }
    }
    .promoText {
      width: 100%;
      margin: 12px 0;
      .main-text {
        color: ${Variables.colors.complementary_900};
        font-size: ${Variables.font_sizes.x_medium};
        line-height: 1.56;
        margin-bottom: 4px;
      }
      .description {
        color: ${Variables.colors.complementary_700};
        font-size: ${Variables.font_sizes.x_small};
      }
    }
  }
`;
export const NotificationListContainer = styled.div`
  overflow-y: auto;
  height: auto;
  max-height: 75vh;
  overflow-x: hidden;
  left: 0;
  width: 100%;
`;

export const FeedbackModalContainer = styled.div`
  .modal-title-icon {
    &:before {
      font-size: ${Variables.font_sizes.x2_medium} !important;
    }
  }

  .response-modal-body-container {
    overflow-y: auto;
    white-space: pre-wrap;
    max-height: 70vh;
    .response-modal-date {
      color: ${Variables.colors.complementary_900};
      font-size: ${Variables.font_sizes.x2_large};
      line-height: 1.55;
    }
    .response-modal-subject {
      color: ${Variables.colors.primary_vivid};
      font-size: ${Variables.font_sizes.x_medium};
      font-weight: ${Variables.font_weight.medium};
      line-height: 1.57;
      margin-top: 8px;
    }
    .response-modal-title {
      max-width: 500px;
      color: ${Variables.colors.complementary_900};
      font-size: ${Variables.font_sizes.x2_large};
      line-height: 1.55;
      margin-top: 24px;
    }
    .images {
      display: flex;
      margin-top: 16px;
      align-items: center;
      .file {
        width: 32px;
        height: 32px;
      }
    }
    .response-modal-description {
      max-width: 400px;
      color: ${Variables.colors.complementary_900};
      font-size: ${Variables.font_sizes.x_medium};
      line-height: 1.57;
      text-align: justify;
      margin-top: 14px;
    }
    .response-modal-rate-section {
      margin-top: 24px;
      display: flex;
      .rating {
        display: flex;
        width: fit-content;
        .unrated-stars {
          display: flex;
          flex-direction: row-reverse;
        }
      }
      .selected {
        color: ${Variables.colors.yellow};
        &:hover {
          color: ${Variables.colors.yellow};
          & ~ .selected {
            color: ${Variables.colors.complementary_500};
          }
        }
      }
      .unselected {
        color: ${Variables.colors.complementary_500};

        &:hover {
          color: ${Variables.colors.yellow};
          &::before {
            content: "\\ea5a";
          }
          & ~ .unselected {
            color: ${Variables.colors.yellow};
            &::before {
              content: "\\ea5a";
            }
          }
        }
      }
      i {
        &:before {
          margin-left: 8px;
        }
      }
    }
    .response-modal-answer-info {
      font-size: ${Variables.font_sizes.x_medium};
      font-weight: ${Variables.font_weight.medium};
      line-height: 1.57;
      margin-top: 12px;
      .ans-date {
        color: ${Variables.colors.complementary_800};
      }
      .ans-name {
        color: ${Variables.colors.complementary_700};
      }
    }
    .link-button-container {
      margin: 10px 0;
      display: flex;
      & > div {
        margin-left: 8px;
      }
    }
  }
`;
